import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AuthProvider } from './auth/AuthContext.jsx';
import { ProtectedRoute } from './auth/ProtectedRoute.jsx';
import { AdminRoute } from './auth/AdminRoute.jsx';
import { FuehrungskraftRoute } from './auth/FuehrungskraftRoute.jsx';
import { AktivitaetModalProvider } from './components/AktivitaetModalProvider.jsx';
import AppShell from './layouts/AppShell.jsx';
import LoginPage from './pages/LoginPage.jsx';
import DashboardPage from './pages/DashboardPage.jsx';
import PraxenListPage from './pages/PraxenListPage.jsx';
import PraxisDetailPage from './pages/PraxisDetailPage.jsx';
import SelektionenListPage from './pages/SelektionenListPage.jsx';
import SelektionDetailPage from './pages/SelektionDetailPage.jsx';
import PartnerPage from './pages/PartnerPage.jsx';
import PartnerDetailPage from './pages/PartnerDetailPage.jsx';
import AuswertungPage from './pages/AuswertungPage.jsx';
import TeamPage from './pages/TeamPage.jsx';
import AdminUsersPage from './pages/AdminUsersPage.jsx';
import AdminImportPage from './pages/AdminImportPage.jsx';
import AdminUpdatesPage from './pages/AdminUpdatesPage.jsx';
import UpdatesPage from './pages/UpdatesPage.jsx';

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AktivitaetModalProvider>
        <Routes>
          <Route path="/login" element={<LoginPage />} />

          <Route
            element={
              <ProtectedRoute>
                <AppShell />
              </ProtectedRoute>
            }
          >
            <Route index element={<DashboardPage />} />
            <Route path="praxen" element={<PraxenListPage />} />
            <Route path="praxen/:id" element={<PraxisDetailPage />} />
            <Route path="selektionen" element={<SelektionenListPage />} />
            <Route path="selektionen/:id" element={<SelektionDetailPage />} />
            <Route path="neuigkeiten" element={<UpdatesPage />} />
            <Route
              path="partner"
              element={
                <FuehrungskraftRoute>
                  <PartnerPage />
                </FuehrungskraftRoute>
              }
            />
            <Route
              path="partner/:id"
              element={
                <FuehrungskraftRoute>
                  <PartnerDetailPage />
                </FuehrungskraftRoute>
              }
            />
            <Route
              path="auswertung"
              element={
                <FuehrungskraftRoute>
                  <AuswertungPage />
                </FuehrungskraftRoute>
              }
            />
            <Route
              path="team"
              element={
                <FuehrungskraftRoute>
                  <TeamPage />
                </FuehrungskraftRoute>
              }
            />
            <Route
              path="admin"
              element={
                <AdminRoute>
                  <AdminUsersPage />
                </AdminRoute>
              }
            />
            <Route
              path="admin/updates"
              element={
                <AdminRoute>
                  <AdminUpdatesPage />
                </AdminRoute>
              }
            />
            <Route
              path="admin/import"
              element={
                <AdminRoute>
                  <AdminImportPage />
                </AdminRoute>
              }
            />
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        </AktivitaetModalProvider>
      </BrowserRouter>
    </AuthProvider>
  );
}
